/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Payload de la section « ETAT MATRIMONIAL » de l'onglet du défunt, envoyé via
 * `service.update` (PUT `/numerisation-actes/deces/{identifiant}`).
 *
 * Un payload d'ACTE dans la modale d'un INDIVIDU : ces colonnes sont sur
 * `ec_actd` mais s'éditent dans l'onglet du défunt, c'est de lui qu'il s'agit.
 *
 * ⚠️ `defuntEtatMatrimonialCode` est le CODE du référentiel, jamais le
 * vocabulaire interne du Cases du modèle : le repository traduit. Et
 * `dateEtatMatrimonial` est unique côté contrat — le back l'aiguille vers la
 * colonne de mariage, de veuvage ou de divorce selon le code.
 *
 * @param identifiant Identifiant de l'ACTE : construit l'URL du PUT.
 * @param data État du formulaire de la modale.
 */
const buildEtatMatrimonialUpdatePayload = (
  identifiant: number,
  data: Record<string, any>,
) => ({
  identifiant,
  acte: {
    identifiant,
    defuntEtatMatrimonialCode: data?.etatMatrimonialCode,
    // Propre au seul état « pacsé » ; le back purge sur toute autre situation.
    defuntEtatMatrimonialCodePacs: data?.etatMatrimonialCodePacs,
    dateEtatMatrimonial: data?.dateEtatMatrimonial,
    defuntSexeExConjoint: data?.sexeExConjoint,
    defuntNomExConjoint: data?.nomExConjoint,
    defuntPrenomExConjoint: data?.prenomExConjoint,
  },
});

export default buildEtatMatrimonialUpdatePayload;
